// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ScreenLayoutService } from 'src/app/modules/shared/services/screen-layout-service/screen-layout.service';
import { SystemOverviewService } from '../../services/systemOverview.service';
import { CompanionsPanelComponent } from '../companions-panel/companions-panel.component';
import { OverviewSwitchComponent } from '../component-overview-switch/overview-switch.component';
import { DocBoxPanelComponent } from '../docBoxPanel/docBoxPanel.component';
import { PlannedActivitiesPanelComponent } from '../planned-activities-panel/planned-activities-panel.component';
import { UsefulApplications } from '../useful-applications/useful-applications';
import { CtsGantryInitStatusComponent } from 'src/app/modules/ct-status/components/cts-gantry-init-status/cts-gantry-init-status.component';
import { CtsGantryVersionService } from 'src/app/modules/ct-status/services/cts-gantry-version.service';
import { SparePartsPanelComponent } from 'src/app/modules/spare-parts/spare-parts-panel/spare-parts-panel.component';
import { AT_NEOCOR_MATERIAL_NUMBERS } from 'src/app/modules/shared/utils/modalityHelpers';

@Component({
  standalone: true,
  selector: 'app-system-overview-default',
  templateUrl: './system-overview-default.component.html',
  styleUrls: [
    '../system-overview/system-overview.component.scss',
    './system-overview-default.component.scss',
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    TranslateModule,
    OverviewSwitchComponent,
    DocBoxPanelComponent,
    CompanionsPanelComponent,
    UsefulApplications,
    PlannedActivitiesPanelComponent,
    CtsGantryInitStatusComponent,
    SparePartsPanelComponent,
  ],
})
export class SystemOverviewDefaultComponent {
  private readonly systemDetails = this.systemOverviewService.systemDetails;
  public systemDetails$ = this.systemDetails.data$;

  public constructor(
    protected readonly systemOverviewService: SystemOverviewService,
    protected readonly screenLayoutService: ScreenLayoutService,
    protected readonly ctsGantryVersionService: CtsGantryVersionService,
  ) {}

  isAtNeoCorSystem(systemMaterialNumber: number): boolean {
    return AT_NEOCOR_MATERIAL_NUMBERS.includes(systemMaterialNumber);
  }
}
